import React, { FC, useState } from "react";
import "./BlockWordModal.css";
import {axiosInstance} from "../../Auth/axiosInstance";
import BlockedWords from "../../Dashboard/Options/BlockedWords/BlockedWords";
import { BlockWordModalProps } from "../ItemGridModel";





const BlockWordModal: FC<BlockWordModalProps> = ({ title, isOpen, onClose }) => {
    const words = title.split(/\s+/); // Split title into words
    const [selectedWords, setSelectedWords] = useState<string[]>([]);
    const [isSaving, setIsSaving] = useState(false)
    const handleCheckboxChange = (word: string, isChecked: boolean): void => {
        setSelectedWords((prev) =>
            isChecked ? [...prev, word] : prev.filter((w) => w !== word)
        );
    };

    const handleSave = async (): Promise<void> => {
        setIsSaving(true);
        try {

            const blockedWords = selectedWords.map((word) => ({
                text: word,
                isTitle: true, // Assuming all blocked words are from the title in this context
            }));
            // Make API request to block words
            await axiosInstance.post("filters/add-blocked-words",
                blockedWords
            );
            alert(`Blocked Word successfuly: ${blockedWords}`);
            onClose(); // Close modal on successful save
        } catch (error) {
            console.error("Error saving blocked words:", error);
        } finally {
            setIsSaving(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Block Words</h3>
                <p>Select words to block from the title:</p>
                <ul className="word-list">
                    {words.map((word) => (
                        <li key={word}>
                            <label>
                                <input
                                    type="checkbox"
                                    onChange={(e) =>
                                        handleCheckboxChange(word, e.target.checked)
                                    }
                                />{" "}
                                {word}
                            </label>
                        </li>
                    ))}
                </ul>
                <div className="modal-actions">
                    <button className="btn-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="btn-save"
                        onClick={handleSave}
                        disabled={isSaving}
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BlockWordModal;
